export default () => ({
    notificationsInit: true,
    notificationsLoading: false,
    notifications: [],
    lastNotifications: [],
    numberOfNewNotifications: 0,
    numActive: 0
});
